"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classNames_1 = require("../../../../../utils/classNames");
const form_control_1 = require("./form-control");
const form_section_1 = require("./form-section");
const heading_1 = require("../../primitives/heading");
const Form = ({ children, actions, title, ...props }) => ((0, jsx_runtime_1.jsxs)("form", { ...props, className: (0, classNames_1.cn)('flex-1 flex-col space-y-[51px]', props.className), children: [title ? ((0, jsx_runtime_1.jsx)(heading_1.Heading, { as: "h3", className: "text-[36px]", children: title })) : null, (0, jsx_runtime_1.jsx)("div", { className: "flex w-full flex-col space-y-[51px]", children: react_1.Children.map(children, (child) => (0, react_1.isValidElement)(child) ? (0, react_1.cloneElement)(child) : child) }), actions] }));
exports.Form = Form;
exports.Form.Section = form_section_1.FormSection;
exports.Form.Control = form_control_1.FormControl;
